import permissions from '@hogwarts/permissions';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { OrganisationContext } from '../../../context';
import { usePermission, useQuery } from '../../../hooks';
import { GET_USER_PROFILE_DOCUMENTS } from '../../../queries';
import styles from './styles.module.css';

interface DocumentCountProps {
  profileId: string;
}

const DocumentCount = ({ profileId }: DocumentCountProps) => {
  const organisation = useContext(OrganisationContext);
  const history = useHistory();
  const allowDocumentList = usePermission(
    permissions.PROFILE_FILE_LIST,
    organisation?.id
  );

  const { data } = useQuery(GET_USER_PROFILE_DOCUMENTS, {
    selector: 'organisations[0].profiles[0].documents',
    variables: {
      organisationKey: organisation?.key,
      profileId,
    },
    skip: !profileId || !organisation || !allowDocumentList,
    fetchPolicy: 'cache-first',
  });

  const count = Array.isArray(data) ? data.length : 0;

  if (!allowDocumentList) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (organisation?.key) {
      history.push(`/${organisation.key}/profiles/${profileId}/documents`);
    }
  };

  return (
    <span>
      {' '}
      (
      <button
        type="button"
        onClick={handleClick}
        className={styles.documentCountLink}
      >
        {count}
      </button>
      )
    </span>
  );
};

export default DocumentCount;
